import React from 'react';
import PendingActionView from './pending';
import RequestDetailModal from '../../travel-expense/detail/index';
import PDFDownload from '../../travel-expense/pdf';

const AllActionViews = (props) => {
  const { request, actionButtonEvents, roles } = props;

  if (request.status === 'pending' || request.status === 'waiting_for_cancelled' || request.status === 'waiting_for_accounting_cancelled') {
    const waitingForCancelled = request && request.status === 'waiting_for_cancelled';

    return (
      <PendingActionView
        roles={roles}
        actionButtonEvents={actionButtonEvents}
        request={request}
        waitingForCancelled={waitingForCancelled}
      />
    );
  }

  if (request.status === 'completed' || request.status === 'rejected' || request.status === 'cancelled' || request.status === 'accounting') {
    return (
      <div>
        <RequestDetailModal
          isManager
          request={request}
        />
        <span>
            &nbsp;
        </span>
        <PDFDownload
          request={request}
        />
        <span>
            &nbsp;
        </span>
      </div>
    );
  }


  return (
    <span>
            Bilinmiyor
    </span>
  );
};

export default AllActionViews;



// WEBPACK FOOTER //
// ./src/components/actions/view/index.js